import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PosIntegrationService } from '../../../../../../services/pos-integration.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { PartnerService } from '../../../../../../services/partner.service';
import { HelpersService } from '../../../../../../services/helpers.service';

@Component({
  selector: 'app-heartlands-defaults',
  templateUrl: './heartlands-defaults.component.html',
  styleUrls: ['./heartlands-defaults.component.scss']
})
export class HeartlandsDefaultsComponent implements OnInit {
  @Input() partner;

  public partnerID;

  public busy = false;
  public config: any = {};
  public registers: any = [];
  public taxes: any = [];
  public locations: any = [];

  public isWizard: boolean = false;

  public isWorkshop = true;
  public isRentals = false;
  public busyTechnicians = false;

  constructor(
    private posIntegrationService: PosIntegrationService,
    //private messageService: MessageService,
    private translate: TranslateService,
    private partnerService: PartnerService,
    private helpersService: HelpersService,
    private router: Router,
  ) {
    if (this.router.url.indexOf('bikeshop-wizard') > -1) {
      this.isWizard = true;
    }
  }

  ngOnInit() {
    if (
      this.router.url.toLocaleLowerCase() ===
      '/bikeshop/rentals/pos-integrations'
    ) {
      this.isRentals = true;
      this.isWorkshop = false;
    }

    this.partnerID = this.partner.ID || this.partner.PartnerID;
    this.getLocations();
    this.getTaxes();

    this.getConfig();
  }

  getLocations() {
    this.posIntegrationService.getLocations(this.partnerID).subscribe((res) => {
      this.locations = res.map((x) => {
        return { label: x.Name, value: x.ID, sourceLocationId: x.WorkflowTypeID };
      });
      console.log('locations', this.locations);
    });
  }

  getTaxes() {
    this.posIntegrationService.getTaxes(this.partnerID).subscribe((res) => {
      this.taxes = res.map((x) => {
        return { label: x.Name, value: parseInt(x.ID) };
      });
      console.log('taxes', this.taxes);
    });
  }

  getConfig() {
    this.posIntegrationService.getConfig(this.partnerID).subscribe(
      (res) => {
        console.log(res);
        this.config = res;

        // Null check and convert StationID to integer
        if (this.config && this.config.StationID != null) {
          this.config.StationID = parseInt(this.config.StationID.toString(), 10);
        }

        // Null check and convert TaxRuleID to integer
        if (this.config && this.config.TaxRuleID != null) {
          this.config.TaxRuleID = parseInt(this.config.TaxRuleID.toString(), 10);
        }    

        // Null check and convert SourceLocationId to integer
        if (this.config && this.config.SourceLocationId != null) {
          this.config.SourceLocationId = parseInt(this.config.SourceLocationId.toString(), 10);
        }

        console.log('config', this.config);
        this.busy = false;
      },
      (err) => {
        this.busy = false;
      },
    );
    this.busy = false;
  }

  onStationChange(event: any) {
  const selected = this.locations.find(loc => loc.value === event.value);
  if (selected) {
    // Assign sourceLocationId from the selected station
    this.config.SourceLocationId = selected.sourceLocationId;
    console.log('Updated SourceLocationID:', this.config.SourceLocationId);
  }
}

    updateConfig() {
    this.busy = true;
    this.config.ID = this.partnerID;
    this.posIntegrationService
      .updateConfig(this.partnerID, this.config)
      .subscribe(
        (result) => {
          this.busy = false;
          //this.messageService.add({ life: 5000, detail: this.translate.instant('onboarding.pos_settings_updated') });
          //this.status.emit({ configurationSaved: true });
        },
        (err) => {
          this.busy = false;
        },
      );
  }

  skipToHubtiger() {
    this.router.navigateByUrl('/bikeshop/calendar');
  }
}
